module.exports = __webpack_public_path__ + "static/media/dont5.f945e728.png";